"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const schedulo_1 = require("schedulo");
const dymo_core_1 = require("dymo-core");
const scheduler_1 = require("./scheduler");
const wrapper_1 = require("./wrapper");
class ScheduloScheduler extends scheduler_1.DymoScheduler {
    constructor(scheduleAheadTime, loadAheadTime, fadeLength) {
        super();
        this.paused = false;
        this.schedulo = new schedulo_1.Schedulo({
            connectToGraph: { countIn: scheduleAheadTime, countOut: 1, minCountIn: scheduleAheadTime },
            loadBuffer: { countIn: loadAheadTime, countOut: 5, minCountIn: loadAheadTime }
        }, fadeLength);
    }
    isPaused() {
        return this.paused;
    }
    pause() {
        this.paused = !this.paused;
        this.schedulo.pause();
    }
    setListenerOrientation(posX, posY, posZ, forwX, forwY, forwZ) {
        //TODO SET ON SCHEDULO!!!
    }
    getAudioBank() {
        return this.schedulo.getAudioBank();
    }
    schedule(dymoUri, previousObject, player) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!dymoUri)
                return Promise.reject('no dymoUri given');
            const newObject = new wrapper_1.ScheduloScheduledObject(dymoUri, previousObject, player);
            let startTime;
            const onset = yield newObject.getParam(dymo_core_1.uris.ONSET);
            let previousOnset;
            if (previousObject) {
                previousOnset = yield previousObject.getParam(dymo_core_1.uris.ONSET);
            }
            if (!isNaN(onset) && !isNaN(previousOnset) && onset - previousOnset >= 0) {
                startTime = schedulo_1.Time.RelativeTo(previousObject.getScheduloObject(), onset - previousOnset);
            }
            else if (previousObject) {
                startTime = schedulo_1.Time.After([previousObject.getScheduloObject()]);
            }
            else {
                startTime = schedulo_1.Time.Asap;
            }
            //console.log(dymoUri, startTime)
            if (yield newObject.isEvent()) {
                const triggerFunction = yield newObject.getTriggerFunction();
                const eventObject = this.schedulo.scheduleEvent(triggerFunction, startTime);
                newObject.setScheduloObject(eventObject);
                return newObject;
            }
            else {
                const audio = yield newObject.getSourcePath();
                const audioObject = this.schedulo.scheduleAudio([audio], startTime, schedulo_1.Playback.Oneshot())[0];
                newObject.setScheduloObject(audioObject);
                //only resolve when audio loaded
                return new Promise(resolve => {
                    audioObject.on('loaded', () => resolve(newObject));
                });
            }
        });
    }
}
exports.ScheduloScheduler = ScheduloScheduler;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-player/lib/schedulo.js
// module id = 1317
// module chunks = 3